import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomButton from '../components/BottomButton';
import BottomSheetConfirmOrder from '../components/BottomSheetConfirmOrder';
import EditUserInfo, { EditUserInfoData } from '../components/EditUserInfo';
import { useDialog } from '../components/GlobalAlertProvider';
import Input from '../components/Input';
import Navbar from '../components/Navbar';
import PrimaryButton from '../components/PrimaryButton';
import SecondaryButton from '../components/SecondaryButton';
import { IconDispatchSm, IconInsurance } from '../components/svgs';
import TableBody from '../components/TableBody';
import TableHeader from '../components/TableHeader';
import { useToast } from '../components/ToastContext';
import { AddsvcStatus } from '../generated/model';
import { useInfoService } from '../hooks/useInfoService';
import { formatAndMaskPhoneNumber, ownerCheck } from '../lib/stringFormat';

function JoinService() {
  const { showAlert } = useDialog();

  const navigate = useNavigate();

  const isOwner = ownerCheck();

  const { tariff, deviceInfo, onOrder, onSubmit, orderSuccess, orderError, modifySuccess } = useInfoService();

  const [selectedAddress, setSelectedAddress] = useState({
    address1: '',
    address2: '',
    zoneCode: '',
  });

  const [doorNum, setDoorNum] = useState('');
  const doorNumRef = useRef<HTMLInputElement>(null);

  const [editing, setEditing] = useState(false);
  const [confirmOrder, setConfirmOrder] = useState(false);
  const [userInfo, setUserInfo] = useState<EditUserInfoData>({
    name: '',
    tel: '',
    zip: '',
    address1: '',
    address2: '',
    doorNum: '',
  });

  const toast = useToast();

  // doorNum 변경 시 userInfo 동기화
  useEffect(() => {
    setUserInfo((prev) => ({
      ...prev,
      doorNum: doorNum,
    }));
  }, [doorNum]);


  //sora27.jeong 26.04.24 해지 후 재가입 시 화면에 표시되는 정보를 deviceinfo가 우선순위가 되도록 한다.
  useEffect(() => {
    if (tariff || deviceInfo) {

      const isCanceledSubscribe =
        tariff?.addsvcStatus === 'C' && tariff?.cancelDate != null;

      setUserInfo({
        name: isCanceledSubscribe
          ? (deviceInfo?.userName ?? '')
          : (tariff?.userName ?? deviceInfo?.userName ?? ''),

        tel: isCanceledSubscribe
          ? (deviceInfo?.userTel ?? '')
          : (tariff?.userTel ?? deviceInfo?.userTel ?? ''),

        zip: isCanceledSubscribe
          ? (deviceInfo?.zip ?? '')
          : (tariff?.zip ?? deviceInfo?.zip ?? ''),

        address1: isCanceledSubscribe
          ? (deviceInfo?.address1 ?? '')
          : (tariff?.address1 ?? deviceInfo?.address1 ?? ''),

        address2: isCanceledSubscribe
          ? (deviceInfo?.address2 ?? '')
          : (tariff?.address2 ?? deviceInfo?.address2 ?? ''),

        doorNum: isCanceledSubscribe
          ? (deviceInfo?.doorPasswd ?? '')
          : (tariff?.doorPasswd ?? deviceInfo?.doorPasswd ?? ''),
      });

      const doorValue = isCanceledSubscribe
        ? (deviceInfo?.doorPasswd ?? '')
        : (tariff?.doorPasswd ?? deviceInfo?.doorPasswd ?? '');

      setDoorNum(doorValue);

      setSelectedAddress({
        address1: isCanceledSubscribe
          ? (deviceInfo?.address1 ?? '')
          : (tariff?.address1 ?? deviceInfo?.address1 ?? ''),

        address2: isCanceledSubscribe
          ? (deviceInfo?.address2 ?? '')
          : (tariff?.address2 ?? deviceInfo?.address2 ?? ''),

        zoneCode: isCanceledSubscribe
          ? (deviceInfo?.zip ?? '')
          : (tariff?.zip ?? deviceInfo?.zip ?? ''),
      });
    }
  }, [tariff, deviceInfo]);

/* 
  useEffect(() => {
    if (tariff) {
      setUserInfo({
        name: tariff.userName || deviceInfo?.userName || '',
        tel: tariff.userTel || deviceInfo?.userTel || '',
        zip: tariff.zip || deviceInfo?.zip || '',
        address1: tariff.address1 || deviceInfo?.address1 || '',
        address2: tariff.address2 || deviceInfo?.address2 || '',
        doorNum: tariff.doorPasswd || deviceInfo?.doorPasswd || '',
      });
      setDoorNum(tariff.doorPasswd || deviceInfo?.doorPasswd || '');
      setSelectedAddress({
        address1: tariff.address1 || deviceInfo?.address1 || '',
        address2: tariff.address2 || deviceInfo?.address2 || '',
        zoneCode: tariff.zip || deviceInfo?.zip || '',
      });
    }
  }, [tariff, deviceInfo]);
 */




  useEffect(() => {
    const onPop = () => setEditing(false);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  useEffect(() => {
    const setViewportHeight = () => {
      const vh = (window.visualViewport?.height || window.innerHeight) * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setViewportHeight();
    window.visualViewport?.addEventListener('resize', setViewportHeight);
    return () => {
      window.visualViewport?.removeEventListener('resize', setViewportHeight);
    };
  }, []);

  // // 부가서비스 주문 결과 모니터링
  // useEffect(() => {
  //   if (orderSuccess) {
  //     showAlert('부가서비스 신청 완료', '부가서비스 신청이 완료되었습니다.').then(() => {
  //       window.location.assign('http://st_camera_command/close');
  //     });
  //   }
  // }, [orderSuccess, showAlert]);

  // useEffect(() => {
  //   if (orderError) {
  //     showAlert('부가서비스 신청 실패', '부가서비스 신청 중 오류가 발생했습니다.');
  //   }
  // }, [orderError, showAlert]);

  // order 추가 서비스 신청 처리
  const handleOrder = () => {
    onOrder({
      serialNo: tariff?.serialNo || deviceInfo?.serialNo || '',
      userName: userInfo.name,
      userTel: userInfo.tel,
      address1: userInfo.address1,
      address2: userInfo.address2 || '',
      zip: userInfo.zip || '-',
      doorPasswd: userInfo.doorNum || '-',
    });
  };

  const handleModify = (data: EditUserInfoData) => {
    setUserInfo({
      name: data.name,
      tel: data.tel,
      zip: data.zip,
      address1: data.address1,
      address2: data.address2 || '',
      doorNum: data.doorNum || '',
    });
    setDoorNum(data.doorNum || '');
    setSelectedAddress({
      address1: data.address1,
      address2: data.address2 || '',
      zoneCode: data.zip,
    });

    onSubmit({
      deviceZip: data.zip || '-',
      deviceAddress1: data.address1,
      deviceAddress2: data.address2 || '',
      doorPasswd: data.doorNum || '-',
      requesterName: data.name,
      requesterTel: data.tel,
    });
  };

  if (editing) {
    return (
      <EditUserInfo
        initial={userInfo}
        joined={tariff?.addsvcStatus === AddsvcStatus.U}
        onSubmit={(data) => {
          if (tariff?.addsvcStatus === AddsvcStatus.U) {
            handleModify(data);
            window.history.back();
          } else {
            setUserInfo(data);
            setEditing(false);
            window.history.back();
          }
        }}
        onCancel={() => {
          setEditing(false);
          window.history.back();
        }}
      />
    );
  }

  return (
    <div className="flex h-screen flex-col">
      <Navbar title="부가서비스" />

      <div className="h-screen-nav overflow-y-auto">
        <div className="p-[8px]">
          <div className="mt-[20px]">
            <TableHeader title="서비스 내용" />

            <div className="mt-4">
              <div className="mb-2 w-full justify-between rounded-[8px] bg-bg_modal px-2 py-[20px]">
                <div className="flex h-[120px] items-start space-x-4 px-2">
                  <div className="w-[56px]">
                    <IconDispatchSm />
                  </div>
                  <div className="">
                    <div className="h-[21px]">
                      <div className="leading-5.5 text-lg font-medium text-white">긴급출동</div>
                    </div>
                    <div className="mt-[11px] h-[34px]">
                      <div className="self-stretch whitespace-pre-wrap break-words text-sm font-medium leading-[18px] text-text_sub">
                        {'위급한 상황에 에스원 출동요원이\n긴급출동하는 서비스'.replace(/\\n/g, '\n')}
                      </div>
                    </div>
                    <div className="mt-[17px] h-[34px]">
                      <div className="self-stretch whitespace-pre-wrap font-['Pretendard'] text-sm font-medium leading-[18px] text-text_primary">
                        {'긴급출동(월 1회 무료)\n월 2회부터 건당 35,000원 과금'.replace(/\\n/g, '\n')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full justify-between rounded-[8px] bg-bg_modal px-2 py-5">
                <div className="flex h-[120px] items-start space-x-4 px-2">
                  <div className="w-[56px]">
                    <IconInsurance />
                  </div>
                  <div>
                    <div className="h-[21px]">
                      <div className="leading-5.5 text-lg font-medium text-white">안심보상</div>
                    </div>
                    <div className="mt-[11px] h-[34px]">
                      <div className="self-stretch whitespace-pre-wrap break-words text-sm font-medium leading-[18px] text-text_sub">
                        {'예기치 못한 사고에 대비하는\n우리집 도난/화재 사고보상서비스'.replace(/\\n/g, '\n')}
                      </div>
                    </div>
                    <div className="mt-[17px] h-[34px]">
                      <div className="self-stretch whitespace-pre-wrap font-['Pretendard'] text-sm font-medium leading-[18px] text-text_primary">
                        {'화재(5천만원), 가정 내 도난(1,500만원)'.replace(/\\n/g, '\n')}
                      </div>
                    </div>
                  </div>
                </div>

                {tariff?.addsvcStatus === AddsvcStatus.U && (
                  <div className="mt-5 flex space-x-2 px-2">
                    <SecondaryButton
                      text="보상 청구 이력"
                      onClick={() => {
                        navigate('/insurancehistory');
                      }}
                      disable={false}
                    />
                    <PrimaryButton
                      text="안심보상 청구"
                      onClick={() => {
                        if (isOwner) {
                          navigate('/insuranceapply');
                        } else {
                          showAlert('안심보상 청구는\n부가서비스 가입자 본인만 가능해요.');
                        }
                      }}
                      disable={false}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="mt-[56px]">
            <div className="mb-[14px]">
              <TableHeader
                title="서비스 대상"
                actionText="정보 변경"
                onClick={() => {
                  window.history.pushState({}, '');
                  setEditing(true);
                }}
              />

              <div className="my-[14px] px-2">
                <div className="justify-start self-stretch font-['Pretendard'] text-[13.95px] font-medium leading-5 text-text_secondary">
                  * 실제 사용자가 다른 경우 이름과 전화번호를 변경해 주세요.
                </div>
                {tariff?.addsvcStatus === AddsvcStatus.U && (
                  <div className="justify-start self-stretch font-['Pretendard'] text-sm font-medium leading-5 text-text_secondary">
                    * 설치주소 변경은 고객센터에 문의해 주세요.
                  </div>
                )}
              </div>

              {(() => {
                const rows: any[] = [
                  { label: '이름', content: userInfo.name },
                  { label: '전화번호', content: formatAndMaskPhoneNumber(userInfo.tel) },
                  {
                    label: '설치주소',
                    content: (
                      <>
                        {userInfo.address1 || selectedAddress.address1}
                        <br />
                        {userInfo.address2 || selectedAddress.address2}
                      </>
                    ),
                  },
                ];
                if (tariff?.addsvcStatus === AddsvcStatus.U) {
                  rows.push({
                    label: '공동현관 출입번호',
                    content: userInfo?.doorNum || '-',
                  });
                }
                return <TableBody rows={rows} />;
              })()}
            </div>

            {tariff?.addsvcStatus !== AddsvcStatus.U && (
              <div className="rounded-lg bg-grayBox py-[10px]">
                <Input
                  ref={doorNumRef}
                  value={doorNum}
                  /* bg-transparent 추가, 포커스 시 아웃라인 제거를 위해 focus:outline-none 추가 */
                  className="rounded-none border-0 bg-transparent px-5 text-base focus:outline-none"
                  onChange={(e) => {
                    setDoorNum(e.target.value);
                  }}
                  placeholder="공동현관 출입번호를 입력해 주세요"
                  onFocus={() => {
                    setTimeout(() => {
                      doorNumRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      const offsetTop = doorNumRef.current?.getBoundingClientRect().top;
                      if (offsetTop) {
                        window.scrollTo({ top: window.scrollY + offsetTop - 100, behavior: 'smooth' });
                      }
                    }, 300);
                  }}
                />
              </div>
            )}
          </div>
          {tariff?.addsvcStatus === AddsvcStatus.U && (
            <div className="self-stretch pt-4 text-center">
              <a
                href="https://www.s1.co.kr/customer/manual/1275?pageNum=1&pageSize=10&status=&type=oss&searchType=all&keyword="
                target="_blank"
                rel="noopener noreferrer"
                className="inline underline underline-offset-4 decoration-1 font-['Pretendard'] text-[13.95px] font-medium leading-5 text-[#7f7f7f]"
              >
                오픈소스
              </a>
            </div>
          )}


        </div>

        {tariff?.addsvcStatus !== AddsvcStatus.U && (
          <div className="mt-[25px] p-2">
            <BottomButton text="부가서비스 신청하기" onClick={() => setConfirmOrder(true)} />
          </div>
        )}





      </div>

      <BottomSheetConfirmOrder
        finalData={userInfo}
        isOpen={confirmOrder}
        onClose={() => setConfirmOrder(false)}
        onSubmit={() => {
          setConfirmOrder(false);
          handleOrder();
        }}
      />
    </div>
  );
}

export default JoinService;
